(function () {
  var header = document.querySelector('.navbar23_component');
  var toggle = header && header.querySelector('[data-nav-toggle]');

  if (toggle && header) {
    toggle.addEventListener('click', function () {
      var isOpen = header.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  document.querySelectorAll('[data-lang-dropdown]').forEach(function (dropdown) {
    var button = dropdown.querySelector('.navbar1_dropdown-toggle');
    if (!button) return;

    button.addEventListener('click', function (event) {
      event.preventDefault();
      var willOpen = !dropdown.classList.contains('is-open');

      document.querySelectorAll('[data-lang-dropdown].is-open').forEach(function (openDropdown) {
        if (openDropdown !== dropdown) {
          openDropdown.classList.remove('is-open');
          var otherToggle = openDropdown.querySelector('.navbar1_dropdown-toggle');
          if (otherToggle) otherToggle.setAttribute('aria-expanded', 'false');
        }
      });

      dropdown.classList.toggle('is-open', willOpen);
      button.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    });
  });

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-lang-dropdown]')) return;
    document.querySelectorAll('[data-lang-dropdown].is-open').forEach(function (dropdown) {
      dropdown.classList.remove('is-open');
      var button = dropdown.querySelector('.navbar1_dropdown-toggle');
      if (button) button.setAttribute('aria-expanded', 'false');
    });
  });

  window.addEventListener('resize', function () {
    if (window.innerWidth > 991 && header && header.classList.contains('is-open')) {
      header.classList.remove('is-open');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    }
  });

  document.querySelectorAll('[data-video-toggle]').forEach(function (button) {
    var container = button.closest('.content-video') || button.parentElement;
    var video = container && container.querySelector('[data-nabio-video]');
    if (!video) return;

    var pauseIcon = button.querySelector('.video-control__icon--pause');
    var playIcon = button.querySelector('.video-control__icon--play');

    function syncControl() {
      var paused = video.paused;
      var playLabel = button.getAttribute('data-play-label') || 'Lire la vidéo';
      var pauseLabel = button.getAttribute('data-pause-label') || 'Mettre la vidéo en pause';
      button.classList.toggle('is-paused', paused);
      button.setAttribute('aria-label', paused ? playLabel : pauseLabel);
      if (pauseIcon) {
        if (paused) pauseIcon.setAttribute('hidden', '');
        else pauseIcon.removeAttribute('hidden');
      }
      if (playIcon) {
        if (paused) playIcon.removeAttribute('hidden');
        else playIcon.setAttribute('hidden', '');
      }
    }

    button.addEventListener('click', function () {
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
      syncControl();
    });

    video.addEventListener('play', syncControl);
    video.addEventListener('pause', syncControl);
    syncControl();
  });

  document.querySelectorAll('[data-video-mute-toggle]').forEach(function (button) {
    var container = button.closest('.content-video') || button.parentElement;
    var video = container && container.querySelector('[data-nabio-video]');
    if (!video) return;

    var mutedIcon = button.querySelector('.video-control__icon--muted');
    var unmutedIcon = button.querySelector('.video-control__icon--unmuted');

    function syncMuteControl() {
      var muted = video.muted;
      var unmuteLabel = button.getAttribute('data-unmute-label') || 'Activer le son';
      var muteLabel = button.getAttribute('data-mute-label') || 'Couper le son';
      button.classList.toggle('is-muted', muted);
      button.setAttribute('aria-label', muted ? unmuteLabel : muteLabel);
      if (mutedIcon) {
        if (muted) mutedIcon.removeAttribute('hidden');
        else mutedIcon.setAttribute('hidden', '');
      }
      if (unmutedIcon) {
        if (muted) unmutedIcon.setAttribute('hidden', '');
        else unmutedIcon.removeAttribute('hidden');
      }
    }

    button.addEventListener('click', function () {
      video.muted = !video.muted;
      if (!video.muted && video.paused) {
        video.play();
      }
      syncMuteControl();
    });

    video.addEventListener('volumechange', syncMuteControl);
    syncMuteControl();
  });

  function initBlockMarquee() {
    var root = document.querySelector('.block-marquee');
    if (!root) return;

    var lazyImages = [].slice.call(root.querySelectorAll('img[data-src]'));
    if ('IntersectionObserver' in window) {
      var lazyImageObserver = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var lazyImage = entry.target;
          lazyImage.src = lazyImage.dataset.src;
          lazyImage.classList.add('active');
          lazyImageObserver.unobserve(lazyImage);
        });
      });
      lazyImages.forEach(function (lazyImage) {
        lazyImageObserver.observe(lazyImage);
      });
    } else {
      lazyImages.forEach(function (lazyImage) {
        lazyImage.src = lazyImage.dataset.src;
      });
    }

    if (typeof gsap === 'undefined') return;

    var marqueeInnerFirst = root.querySelector('.marquee-inner.-first');
    var marqueeInnerLast = root.querySelector('.marquee-inner.-last');
    if (!marqueeInnerFirst || !marqueeInnerLast) return;

    var marqueeAllFirst = marqueeInnerFirst.querySelectorAll('.marquee');
    var marqueeAllLast = marqueeInnerLast.querySelectorAll('.marquee');
    if (!marqueeAllFirst.length || !marqueeAllLast.length) return;

    var marqueeContentWidthFirst = marqueeAllFirst[0].offsetWidth;
    var marqueeContentWidthLast = marqueeAllLast[0].offsetWidth;
    if (!marqueeContentWidthFirst || !marqueeContentWidthLast) return;

    gsap.timeline().to(marqueeAllFirst, {
      duration: 40,
      ease: 'none',
      x: '-=' + marqueeContentWidthFirst,
      modifiers: {
        x: gsap.utils.unitize(function (x) {
          return parseFloat(x) % marqueeContentWidthFirst;
        })
      },
      repeat: -1
    });

    gsap.set(marqueeAllLast, { x: '-100%' });
    gsap.timeline().to(marqueeAllLast, {
      duration: 40,
      ease: 'none',
      x: '+=' + marqueeContentWidthLast,
      modifiers: {
        x: gsap.utils.unitize(function (x) {
          return parseFloat(x) % -marqueeContentWidthLast;
        })
      },
      repeat: -1
    });
  }

  function whenReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = (Number(cents) || 0) / 100;
    var formatString = format || '${{amount}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var match = formatString.match(placeholder);
    var moneyFormat = match ? match[1] : 'amount';
    var amount = value.toFixed(2);
    if (moneyFormat === 'amount_no_decimals') amount = Math.round(value).toString();
    if (moneyFormat === 'amount_with_comma_separator') amount = value.toFixed(2).replace('.', ',');
    return formatString.replace(placeholder, amount);
  }

  function getFeaturedImage(root) {
    return (
      root.querySelector('[data-featured-image]') ||
      root.querySelector('[data-product-media] img.nabio-product__image') ||
      root.querySelector('[data-product-media] img')
    );
  }

  function initProductGallery(root) {
    var thumbs = root.querySelectorAll('[data-thumb]');
    if (!thumbs.length) return;

    function activateThumb(thumb) {
      var featured = getFeaturedImage(root);
      var src = thumb.getAttribute('data-media-src');
      var alt = thumb.getAttribute('data-media-alt') || '';
      if (!featured || !src) return;

      featured.src = src;
      featured.removeAttribute('srcset');
      featured.alt = alt;

      thumbs.forEach(function (el) {
        el.classList.toggle('is-active', el === thumb);
      });
    }

    function activeIndex() {
      var index = 0;
      thumbs.forEach(function (el, i) {
        if (el.classList.contains('is-active')) index = i;
      });
      return index;
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        activateThumb(thumb);
      });
    });

    var prevBtn = root.querySelector('[data-gallery-prev]');
    var nextBtn = root.querySelector('[data-gallery-next]');

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        var index = activeIndex();
        var next = (index - 1 + thumbs.length) % thumbs.length;
        activateThumb(thumbs[next]);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        var index = activeIndex();
        var next = (index + 1) % thumbs.length;
        activateThumb(thumbs[next]);
      });
    }
  }

  function initProductTabs(root) {
    var tabsRoot = root.querySelector('[data-product-tabs]');
    if (!tabsRoot) return;

    var tabs = tabsRoot.querySelectorAll('[data-tab]');
    var panels = tabsRoot.querySelectorAll('[data-panel]');

    function activate(key) {
      tabs.forEach(function (tab) {
        var selected = tab.getAttribute('data-tab') === key;
        tab.classList.toggle('is-active', selected);
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.tabIndex = selected ? 0 : -1;
      });
      panels.forEach(function (panel) {
        var selected = panel.getAttribute('data-panel') === key;
        panel.classList.toggle('is-active', selected);
        if (selected) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activate(tab.getAttribute('data-tab'));
      });
    });
  }

  function initQtyStepper(root) {
    var steppers = root.querySelectorAll('[data-qty-stepper]');
    steppers.forEach(function (stepper) {
      var input = stepper.querySelector('[data-qty-input]');
      var minus = stepper.querySelector('[data-qty-minus]');
      var plus = stepper.querySelector('[data-qty-plus]');
      if (!input) return;

      function clamp() {
        var min = Number(input.min || 1);
        var max = input.max ? Number(input.max) : null;
        var value = Number(input.value || min);
        if (isNaN(value) || value < min) value = min;
        if (max != null && value > max) value = max;
        input.value = String(value);
        return value;
      }

      if (minus) {
        minus.addEventListener('click', function () {
          input.value = String(Math.max(Number(input.min || 1), Number(input.value || 1) - 1));
          clamp();
        });
      }
      if (plus) {
        plus.addEventListener('click', function () {
          var max = input.max ? Number(input.max) : null;
          var next = Number(input.value || 1) + 1;
          if (max != null) next = Math.min(max, next);
          input.value = String(next);
          clamp();
        });
      }
      input.addEventListener('change', clamp);
    });
  }

  function cartRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function refreshCartCount() {
    fetch(cartRoot().replace(/\/?$/, '/') + 'cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        var count = cart.item_count || 0;
        document.querySelectorAll('[data-cart-count], .navbar23_cart-count, .navbar23_cart-badge').forEach(function (el) {
          el.textContent = String(count);
          if (el.classList.contains('navbar23_cart-badge')) {
            el.hidden = !count;
            if (!count) el.style.display = 'none';
            else el.style.display = '';
          } else {
            el.hidden = !count;
          }
        });
        document.dispatchEvent(new CustomEvent('nabio:cart:updated', { detail: cart }));
      })
      .catch(function () {});
  }

  function initRelatedProducts() {
    var section = document.querySelector('[data-nabio-related][data-url]');
    if (!section) return;
    var grid = section.querySelector('.nabio-related__grid');
    if (grid && grid.children.length) return;

    fetch(section.getAttribute('data-url'))
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.querySelector('[data-nabio-related]');
        if (next && next.innerHTML.trim()) {
          section.outerHTML = next.outerHTML;
        }
      })
      .catch(function () {});
  }

  function addToCart(payload) {
    return fetch(cartRoot().replace(/\/?$/, '/') + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    }).then(function (res) {
      if (!res.ok) {
        return res.json().then(function (err) {
          throw err;
        });
      }
      return res.json();
    });
  }

  function initProductPage() {
    var root = document.querySelector('[data-nabio-product]');
    if (!root) return;

    // Gallery must work even if product JSON fails to parse.
    initProductGallery(root);
    initProductTabs(root);
    initQtyStepper(root);

    var jsonEl = root.querySelector('[data-product-json]');
    if (!jsonEl) return;

    var product;
    try {
      product = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return;
    }

    var variantInput = root.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare-price]');
    var submitBtn = root.querySelector('[data-add-to-cart]');
    var submitLabel = root.querySelector('[data-add-to-cart-label]');
    var optionSelects = root.querySelectorAll('[data-option-select]');
    var moneyFormat = root.getAttribute('data-money-format') || '{{amount}} $';
    var addLabel = submitBtn && submitBtn.getAttribute('data-add-label');
    var soldOutLabel = submitBtn && submitBtn.getAttribute('data-sold-out-label');
    var sticky = root.querySelector('[data-sticky-atc]');
    var stickyPrice = root.querySelector('[data-sticky-price]');
    var stickyTitle = root.querySelector('[data-sticky-title]');
    var stickyAdd = root.querySelector('[data-sticky-add]');
    var stickyImage = root.querySelector('[data-sticky-image]');
    var buybox = root.querySelector('[data-product-buybox]');
    var variantPill = root.querySelector('[data-variant-pill]');
    var qtyInput = root.querySelector('[data-qty-input]');
    var currentVariant = null;

    function getSelectedOptions() {
      var selected = [];
      optionSelects.forEach(function (select) {
        selected[Number(select.getAttribute('data-option-position')) - 1] = select.value;
      });
      return selected;
    }

    function findVariant(options) {
      return (product.variants || []).find(function (variant) {
        return variant.options.every(function (option, index) {
          return option === options[index];
        });
      });
    }

    function setSubmitState(available) {
      if (!submitBtn) return;
      submitBtn.disabled = !available;
      var label = available ? (addLabel || '') : (soldOutLabel || '');
      if (submitLabel) {
        submitLabel.textContent = label;
      } else {
        submitBtn.textContent = label;
      }
      if (stickyAdd) {
        stickyAdd.disabled = !available;
        stickyAdd.textContent = addLabel || stickyAdd.textContent;
      }
    }

    function updateVariantPill(variant) {
      if (!variantPill || !variant) return;
      var parts = [];
      (product.options || []).forEach(function (name, index) {
        if (variant.options && variant.options[index]) {
          parts.push(name + ' : ' + variant.options[index]);
        }
      });
      variantPill.textContent = parts.join(' · ');
    }

    function updateVariant() {
      var variant = optionSelects.length
        ? findVariant(getSelectedOptions())
        : product.variants && product.variants[0];

      currentVariant = variant || null;

      if (!variant) {
        setSubmitState(false);
        return;
      }

      if (variantInput) variantInput.value = variant.id;

      if (priceEl) {
        priceEl.textContent = formatMoney(variant.price, moneyFormat);
        priceEl.classList.toggle('nabio-price--sale', !!(variant.compare_at_price && variant.compare_at_price > variant.price));
      }

      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.hidden = false;
          compareEl.textContent = formatMoney(variant.compare_at_price, moneyFormat);
        } else {
          compareEl.hidden = true;
          compareEl.textContent = '';
        }
      }

      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price, moneyFormat);
      if (stickyTitle) stickyTitle.textContent = product.title || stickyTitle.textContent;
      if (stickyImage && variant.featured_image && variant.featured_image.src) {
        stickyImage.src = variant.featured_image.src;
      }

      updateVariantPill(variant);
      setSubmitState(!!variant.available);
    }

    optionSelects.forEach(function (select) {
      select.addEventListener('change', updateVariant);
    });

    updateVariant();

    if (sticky && buybox && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            sticky.hidden = entry.isIntersecting;
          });
        },
        { root: null, threshold: 0, rootMargin: '0px 0px -20% 0px' }
      );
      observer.observe(buybox);
    } else if (sticky) {
      sticky.hidden = true;
    }

    if (stickyAdd) {
      stickyAdd.addEventListener('click', function () {
        if (!currentVariant || !currentVariant.available) return;
        var quantity = qtyInput ? Number(qtyInput.value || 1) : 1;
        stickyAdd.disabled = true;
        addToCart({ id: currentVariant.id, quantity: quantity })
          .then(function () {
            refreshCartCount();
          })
          .catch(function () {})
          .finally(function () {
            stickyAdd.disabled = !currentVariant || !currentVariant.available;
          });
      });
    }

    var assemblyBtn = root.querySelector('[data-add-assembly]');
    if (assemblyBtn) {
      var assemblyAddLabel = assemblyBtn.getAttribute('data-add-label');
      var assemblyAddedLabel = assemblyBtn.getAttribute('data-added-label');
      assemblyBtn.addEventListener('click', function () {
        var variantId = Number(assemblyBtn.getAttribute('data-assembly-variant-id'));
        if (!variantId) return;
        assemblyBtn.disabled = true;
        addToCart({ id: variantId, quantity: 1 })
          .then(function () {
            refreshCartCount();
            if (assemblyAddedLabel) assemblyBtn.textContent = assemblyAddedLabel;
            window.setTimeout(function () {
              if (assemblyAddLabel) assemblyBtn.textContent = assemblyAddLabel;
              assemblyBtn.disabled = false;
            }, 1600);
          })
          .catch(function () {
            assemblyBtn.disabled = false;
          });
      });
    }
  }

  function initSearchOverlay() {
    var overlay = document.querySelector('[data-search-overlay]');
    if (!overlay) return;

    var openButtons = document.querySelectorAll('[data-search-open]');
    var closeButtons = overlay.querySelectorAll('[data-search-close]');
    var input = overlay.querySelector('[data-search-input]');
    var results = overlay.querySelector('[data-predictive-search-results]');
    var status = overlay.querySelector('[data-search-status]');
    var viewAll = overlay.querySelector('[data-search-view-all]');
    var debounceTimer = null;
    var abortController = null;
    var lastFocused = null;
    var searchRoot =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var loadingLabel = overlay.getAttribute('data-loading-label') || 'Recherche…';

    function setStatus(message, visible) {
      if (!status) return;
      if (visible && message) {
        status.textContent = message;
        status.hidden = false;
      } else {
        status.textContent = '';
        status.hidden = true;
      }
    }

    function updateViewAll(query) {
      if (!viewAll) return;
      var q = (query || '').trim();
      if (!q) {
        viewAll.hidden = true;
        viewAll.href = searchRoot.replace(/\/?$/, '/') + 'search';
        return;
      }
      viewAll.hidden = false;
      viewAll.href = searchRoot.replace(/\/?$/, '/') + 'search?q=' + encodeURIComponent(q) + '&type=product';
    }

    function clearResults() {
      if (results) results.innerHTML = '';
      setStatus('', false);
      updateViewAll('');
    }

    function openOverlay() {
      lastFocused = document.activeElement;
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('nabio-search-open');
      openButtons.forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'true');
      });
      if (input) {
        window.setTimeout(function () {
          input.focus();
          input.select();
        }, 50);
      }
    }

    function closeOverlay() {
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('nabio-search-open');
      openButtons.forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'false');
      });
      if (abortController) {
        abortController.abort();
        abortController = null;
      }
      if (lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus();
      }
    }

    function fetchPredictive(query) {
      var q = (query || '').trim();
      updateViewAll(q);

      if (!q) {
        if (abortController) {
          abortController.abort();
          abortController = null;
        }
        clearResults();
        return;
      }

      if (abortController) abortController.abort();
      abortController = new AbortController();
      setStatus(loadingLabel, true);

      var url =
        searchRoot.replace(/\/?$/, '/') +
        'search/suggest?q=' +
        encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=8&section_id=predictive-search';

      fetch(url, { signal: abortController.signal })
        .then(function (response) {
          if (!response.ok) throw new Error('Predictive search failed');
          return response.text();
        })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var section = doc.querySelector('#shopify-section-predictive-search');
          if (results) {
            results.innerHTML = section ? section.innerHTML : '';
          }
          setStatus('', false);
          updateViewAll(q);
        })
        .catch(function (error) {
          if (error && error.name === 'AbortError') return;
          if (results) results.innerHTML = '';
          setStatus('', false);
          updateViewAll(q);
        });
    }

    openButtons.forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        openOverlay();
      });
    });

    closeButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        closeOverlay();
      });
    });

    if (input) {
      input.addEventListener('input', function () {
        var value = input.value;
        window.clearTimeout(debounceTimer);
        debounceTimer = window.setTimeout(function () {
          fetchPredictive(value);
        }, 300);
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && overlay.classList.contains('is-open')) {
        closeOverlay();
      }
    });
  }

  function initCreationsGallery() {
    var pageGallery = document.querySelector('[data-nabio-creations]');
    if (!pageGallery) return;

    var lazyImages = [].slice.call(pageGallery.querySelectorAll('.gallery img[data-src]'));
    if ('IntersectionObserver' in window) {
      var lazyImageObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var lazyImage = entry.target;
          lazyImage.src = lazyImage.dataset.src || lazyImage.getAttribute('data-src');
          lazyImage.classList.add('active');
          lazyImageObserver.unobserve(lazyImage);
        });
      });
      lazyImages.forEach(function (lazyImage) {
        lazyImageObserver.observe(lazyImage);
      });
    } else {
      lazyImages.forEach(function (lazyImage) {
        lazyImage.src = lazyImage.dataset.src || lazyImage.getAttribute('data-src');
        lazyImage.classList.add('active');
      });
    }

    function initLightGalleries() {
      if (typeof lightGallery === 'undefined') return;
      var plugins = [];
      if (typeof lgZoom !== 'undefined') plugins.push(lgZoom);
      if (typeof lgThumbnail !== 'undefined') plugins.push(lgThumbnail);

      pageGallery.querySelectorAll('.gallery').forEach(function (gallery) {
        if (gallery.dataset.lgInitialized === 'true') return;
        lightGallery(gallery, {
          selector: '.image-container',
          plugins: plugins,
          speed: 500,
          download: false,
          exThumbImage: 'data-thumb',
          licenseKey: '0000-0000-000-0000'
        });
        gallery.dataset.lgInitialized = 'true';
      });
    }

    initLightGalleries();
    if (typeof lightGallery === 'undefined') {
      var tries = 0;
      var timer = setInterval(function () {
        tries += 1;
        if (typeof lightGallery !== 'undefined' || tries > 40) {
          clearInterval(timer);
          initLightGalleries();
        }
      }, 50);
    }

    pageGallery.querySelectorAll('.c-product-icon').forEach(function (item) {
      item.addEventListener('click', function (e) {
        e.stopPropagation();
        e.stopImmediatePropagation();
      });
    });

    pageGallery.querySelectorAll('[data-gallery-tab]').forEach(function (button) {
      button.addEventListener('click', function () {
        var key = button.getAttribute('data-gallery-tab');
        pageGallery.querySelectorAll('[data-gallery-panel]').forEach(function (panel) {
          var show = panel.getAttribute('data-gallery-panel') === key;
          if (show) {
            panel.removeAttribute('hidden');
            panel.style.display = 'block';
          } else {
            panel.setAttribute('hidden', '');
            panel.style.display = 'none';
          }
        });
        pageGallery.querySelectorAll('[data-gallery-tab]').forEach(function (btn) {
          var active = btn === button;
          btn.classList.toggle('active', active);
          btn.setAttribute('aria-selected', active ? 'true' : 'false');
        });
      });
    });
  }

  whenReady(function () {
    initProductPage();
    initRelatedProducts();
    initSearchOverlay();
    initCreationsGallery();

    // GSAP is loaded with defer; wait a tick if needed.
    if (typeof gsap !== 'undefined') {
      initBlockMarquee();
      return;
    }
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (typeof gsap !== 'undefined' || tries > 40) {
        clearInterval(timer);
        initBlockMarquee();
      }
    }, 50);
  });
})();
